module.exports = __webpack_public_path__ + "static/wallet@2x-012fbe81ab11e4f6e26bd8bd037a4d19.webp";